import { render, staticRenderFns } from "./BankTransfer.vue?vue&type=template&id=d37ed8f8"
import script from "./BankTransfer.vue?vue&type=script&lang=js"
export * from "./BankTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme2DesktopDepositStep: require('/app/components/Theme2/Desktop/DepositStep.vue').default,CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default,Theme2DesktopBankAccountCard: require('/app/components/Theme2/Desktop/BankAccountCard.vue').default,CommonsCopyButton: require('/app/components/Commons/CopyButton.vue').default})
